var map = {
	"./animations.scss": "bc44",
	"./colors.scss": "62d7",
	"./community.png": "7ee2",
	"./conference_call.svg": "1bd5",
	"./desk.svg": "0e01",
	"./desktop.css": "ebf2",
	"./edgeryders_1.jpg": "b88a",
	"./edgeryders_2.jpg": "b0ff",
	"./edgeryders_group.jpg": "1502",
	"./ethnography.png": "c744",
	"./graphryder.png": "09b4",
	"./img/press/dazed.png": "e532",
	"./img/press/di.png": "8f5d",
	"./img/press/guardian.jpg": "cb37",
	"./img/press/huffpost.jpg": "a2d1",
	"./img/press/ilsole24ore.png": "703e",
	"./img/press/krautreporter.png": "9c2e",
	"./img/press/mutinerie.png": "da96",
	"./img/press/nation.png": "e536",
	"./img/press/nesta.png": "ceff",
	"./img/press/newyorker.jpg": "ec78",
	"./img/press/opengov.png": "4a73",
	"./img/press/republica.png": "4bd5",
	"./img/press/wired.png": "6a6f",
	"./index.scss": "139c",
	"./mailchimp-gdpr.svg": "41fe",
	"./main.css": "845f",
	"./mixins.scss": "ebdc",
	"./mooc.png": "4139",
	"./ngi_logo.png": "e9b1",
	"./oci.svg": "ada1",
	"./oci_contributor.svg": "2655",
	"./oci_lab.png": "6404",
	"./oci_leader.svg": "fa86",
	"./oci_owner.svg": "9148",
	"./questions.svg": "e034",
	"./robin.mp4": "a700",
	"./typography.scss": "db8c",
	"./world.svg": "32d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";